import { IMedium } from '../../store/VideoStore';
import { style, direct } from '../../utils/image';
import { isAndroid, isIos } from '../../utils/util';
import { videoLayout } from './Player';

let flag = false;

const PluginException = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(source: IMedium, onException?: (isPlay: boolean) => void) {
        this.source = source;
        this.timer = 0;
        this.player = null;
        this.dom = null;
        this.secondVideo = null;
        this.secondTimer = 0;
        this.bindErrorRetry = this.errorRetry.bind(this);
        this.onException = onException;
      },
      createEl: function(el: any, player: any) {
        console.log('createEl once');
        this.el = el;
        this.player = player;

        let backContainer = document.createElement('div');
        backContainer.className = 'player-exception';

        // 现在就要判断是图片还是视频
        let { type, source_detail } = this.source;
        if (type == 'live' && source_detail) {
          let { second_url, cover_img } = source_detail;
          if (second_url || cover_img) {
            let finalUrl = second_url;
            let finalType = '';

            if (finalUrl) {
              if (finalUrl.match(/\.mp4/gi)) {
                finalType = 'video';
              } else {
                finalType = 'image';
              }
            } else {
              finalType = 'image';
              finalUrl = cover_img;
            }

            let videoContainer = document.createElement('div');
            videoContainer.setAttribute('id', this.el.id + '_second');
            videoContainer.className = 'extra-player-exception';
            this.dom = videoContainer;

            this.el.parentNode.appendChild(videoContainer);
            if (finalType == 'video') {
              // 如果是视频的话，又要麻烦一点了，新建一个视频播放器
              let video = new window.Aliplayer(
                {
                  id: this.el.id + '_second',
                  width: '100%',
                  height: '100%',
                  useH5Prism: true,
                  playsinline: true,
                  showBuffer: true,
                  x5_type: 'h5',
                  controlBarVisibility: 'hover',
                  showBarTime: 1000,
                  autoplay: false,
                  replay: true,
                  isLive: false,
                  cover: style(cover_img, 'wx_750_420'),
                  // liveRetry:5,
                  // @ts-ignore
                  language: window.configDetail.locale.toLowerCase(),
                  source: direct(finalUrl),
                  skinLayout: [{ name: 'bigPlayButton', align: 'cc' }]
                },
                function(instance: any) {}
              );
              this.secondVideo = video;
            }
            if (finalType == 'image') {
              let image = document.createElement('img');
              image.src =
                finalUrl.indexOf(`//`) >= 0
                  ? finalUrl
                  : style(finalUrl, 'wx_750_420');
              this.dom.appendChild(image);
            }
          }
        }
      },
      errorRetry: function(havetry: boolean = false) {
        // this.player.loadByUrl(this.player.getSourceUrl());
        // 手工检测
        let url = this.player.getSourceUrl();
        fetch(url)
          .then((res: any) => {
            if (res && res.ok && [200, 304].indexOf(Number(res.status)) > -1) {
              console.log(
                'reload video url',
                havetry,
                this.player.getSourceUrl()
              );

              this.hideSecond();
              flag = true;

              if (!havetry) {
                this.player.loadByUrl(this.player.getSourceUrl());

                // 如果是ios
                if (isIos()) {
                  // ios下，断流恢复后，无法播放成功，干脆直接销毁后重新建一个吧
                  window.dispatchEvent(new Event('custom-dispose-player'));
                }
              }
            } else {
              this.error(this.player, {
                type: 'Retry',
                message: 'Retry Error'
              });
            }
          })
          .catch((e: any) => {
            this.error(this.player, { type: 'Retry', message: 'Retry Error' });
          });
      },
      showSecond: function() {
        console.log('show second');
        if (this.dom) {
          this.dom.style.display = 'block';

          if (this.secondVideo) {
            this.secondVideo.play();
          }

          if (isAndroid()) {
            // this.el.style.transform = `translateX(2000px)`;
          }
        }

        if (this.onException) {
          this.onException(false);
        }
      },
      hideSecond: function() {
        console.log('hide second');
        if (this.dom) {
          this.dom.style.display = 'none';

          if (this.secondVideo) {
            this.secondVideo.pause();
          }

          if (isAndroid()) {
            // this.el.style.transform = `translateX(0)`;
          }
        }

        if (this.onException) {
          this.onException(true);
        }
      },
      play: function(player: any) {
        console.log('exception play', Date.now(), player);
        clearTimeout(this.timer);
      },
      pause: function(player: any) {
        console.log('exception pause', Date.now(), player);
        clearTimeout(this.secondTimer);

        if (isAndroid() && !flag) {
          // 在Android端，暂停后，需要去额外检测，是否是因为断流而存在的暂停
          // 如果流文件没有问题，那相安无事了，如果流文件本身有问题，则会接上之前的异常流程
          clearTimeout(this.timer);
          this.timer = setTimeout(this.bindErrorRetry, 5000);
        }
      },
      error: function(player: any, e: any) {
        this.player = player;
        console.log('error', e, player);
        // 已经重试后失败，那么应该开启下一次的检测，假定每10秒一次检查，差不多了吧
        clearTimeout(this.timer);
        this.timer = setTimeout(this.bindErrorRetry, 5000);
        // 当出现错误的时候，一定是暂停了的
        // 当恢复加载后，则会触发play事件
        this.showSecond();
      }
    })
  : null;

export default PluginException;
